import { API } from "../../../services";
import { handleResponse } from "../../../helpers";
import { API_URL } from "../../../config/appConfig";

const basePath = `${API_URL.idp}/system/role`;

const getAllSystemRoles = async () => {
  return API.get(basePath, "system_roles_list").then(handleResponse);
};

const getSystemRoleByName = async (roleName) => {
  return API.get(
    `${basePath}/${encodeURIComponent(roleName)}`,
    "system_role_by_name"
  ).then(handleResponse);
};

const createSystemRole = async (payload) => {
  return API.post(basePath, "system_role_create", {
    name: payload.name,
    allow: payload.allow || [],
  }).then(handleResponse);
};

const updateSystemRole = async (roleId, payload) => {
  return API.put(`${basePath}/${roleId}`, "system_role_update", {
    allow: payload.allow || [],
  }).then(handleResponse);
};

const deleteSystemRole = async (roleId) => {
  return API.delete(`${basePath}/${roleId}`, "system_role_delete").then(
    handleResponse
  );
};

export const systemRoleService = {
  getAllSystemRoles,
  getSystemRoleByName,
  createSystemRole,
  updateSystemRole,
  deleteSystemRole,
};
